import {
  deleteTPSDAAwardMapping,
  deleteTPSFuelPriceMapping,
  deleteTPSGenMapping,
  deleteTPSLmpMapping,
  deleteTPSMakeWholeMapping,
  getTPSDAAwardData,
  getTPSDAAwardMapping,
  getTPSFuelPriceData,
  getTPSFuelPriceMapping,
  getTPSGenData,
  getTPSGenMapping,
  getTPSLmpData,
  getTPSLmpMapping,
  getTPSMakeWholeData,
  getTPSMakeWholeMapping,
  importTPSDAAwardData,
  importTPSFuelPriceData,
  importTPSGenData,
  importTPSLmpData,
  importTPSMakeWholeData,
  saveTPSDAAwardMapping,
  saveTPSFuelPriceMapping,
  saveTPSGenMapping,
  saveTPSLmpMapping,
  saveTPSMakeWholeMapping,
} from 'api/pgads'

const { strCol, dateTimeCol, numCol } = require('@integec/grid-tools/lib/cols')
const {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  // unitHeader,
  unitIdHeader,
} = require('core/HeaderColTypeProps')

const genMappingHeaders = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'emktId',
    display: 'EMKT ID',
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'elementName',
    display: 'Element Name',
    width: 300,
    sortOrder: 'asc',
    alignment: 'left',
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]
const lmpMappingHeaders = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'pnodeId',
    display: 'PNODE ID',
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'elementName',
    display: 'Element Name',
    width: 300,
    sortOrder: 'asc',
    alignment: 'left',
    isKey: true,
  }),
  modifierCol,
  modifiedDateCol,
]
const fuelpriceMappingHeaders = [
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'emktId',
    display: 'EMKT ID',
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'elementName',
    display: 'Element Name',
    width: 300,
    sortOrder: 'asc',
    isKey: true,
    alignment: 'left',
  }),
  strCol({
    ident: 'customXslt',
    display: 'Custom XSLT',
    width: 300,
    sortOrder: 'asc',
    alignment: 'left',
    ellipsis: true,
  }),
  strCol({
    ident: 'customUrl',
    display: 'Custom URL',
    width: 450,
    sortOrder: 'asc',
    alignment: 'left',
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]
const genDataHeaders = extraCols => [
  unitIdHeader,
  strCol({
    ident: 'emktId',
    display: 'EMKT ID',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'locationName',
    display: 'Location Name',
    isFiltered: true,
    width: 450,
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'transdateGmt',
    display: 'Transdate (GMT)',
    width: 200,
    isFiltered: true,
    sortOrder: 'desc',
  }),
  dateTimeCol({
    ident: 'transdate',
    display: 'Transdate (Local)',
    width: 200,
    isFiltered: true,
    sortOrder: 'desc',
  }),
  ...extraCols,
  modifierCol,
  modifiedDateCol,
]
const lmpDataHeaders = [
  unitIdHeader,
  strCol({
    ident: 'pnodeId',
    display: 'PNODE ID',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'elementName',
    display: 'Element Name',
    isFiltered: true,
    width: 450,
    sortOrder: 'asc',
    alignment: 'left',
  }),
  strCol({
    ident: 'transdateGmt',
    display: 'Transdate (GMT)',
    width: 200,
    isFiltered: true,
    sortOrder: 'desc',
  }),
  dateTimeCol({
    ident: 'transdate',
    display: 'Transdate (Local)',
    width: 200,
    isFiltered: true,
    sortOrder: 'desc',
  }),
  numCol({
    ident: 'rtLmp',
    display: 'RT LMP',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
  }),
  numCol({
    ident: 'dalLmp',
    display: 'DA LMP',
    isFiltered: true,
    sortOrder: 'asc',
    alignment: 'right',
  }),
  modifierCol,
  modifiedDateCol,
]

const genonMappingScreens = [
  'tps-gen-mapping',
  'tps-lmp-mapping',
  'tps-daaward-mapping',
  'tps-makewhole-mapping',
  'tps-fuelprice-mapping',
]

const genonDataScreens = [
  'tps-gen-data',
  'tps-lmp-data',
  'tps-daaward-data',
  'tps-makewhole-data',
  'tps-fuelprice-data',
]

export { genonMappingScreens, genonDataScreens }

const screenProps = {
  'tps-gen-mapping': {
    title: 'GEN Mapping (TPS Interface)',
    headers: genMappingHeaders,
    commonScreenProps: { autoRetrieve: true },
    saveTask: saveTPSGenMapping,
    retrieveTask: getTPSGenMapping,
    deleteTask: deleteTPSGenMapping,
  },
  'tps-lmp-mapping': {
    title: 'LMP Mapping (TPS Interface)',
    headers: lmpMappingHeaders,
    commonScreenProps: { autoRetrieve: true },
    saveTask: saveTPSLmpMapping,
    retrieveTask: getTPSLmpMapping,
    deleteTask: deleteTPSLmpMapping,
  },
  'tps-daaward-mapping': {
    title: 'DA Award Mapping (TPS Interface)',
    headers: genMappingHeaders,
    commonScreenProps: { autoRetrieve: true },
    saveTask: saveTPSDAAwardMapping,
    retrieveTask: getTPSDAAwardMapping,
    deleteTask: deleteTPSDAAwardMapping,
  },
  'tps-makewhole-mapping': {
    title: 'Make Whole Mapping (TPS Interface)',
    headers: genMappingHeaders,
    commonScreenProps: { autoRetrieve: true },
    saveTask: saveTPSMakeWholeMapping,
    retrieveTask: getTPSMakeWholeMapping,
    deleteTask: deleteTPSMakeWholeMapping,
  },
  'tps-fuelprice-mapping': {
    title: 'Fuel Price Mapping (TPS Interface)',
    headers: fuelpriceMappingHeaders,
    insertCompProps: {
      gridTemplateColumns:
        '100px 400px 50px 50px 100px 120px 120px 180px 100px 150px',
    },
    commonScreenProps: { autoRetrieve: true },
    saveTask: saveTPSFuelPriceMapping,
    retrieveTask: getTPSFuelPriceMapping,
    deleteTask: deleteTPSFuelPriceMapping,
  },
  'tps-gen-data': {
    title: 'Generation Data (TPS Interface)',
    headers: genDataHeaders([
      numCol({
        ident: 'aux',
        display: 'AUX',
        isFiltered: true,
        sortOrder: 'asc',
        alignment: 'right',
      }),
      numCol({
        ident: 'net',
        display: 'NET',
        isFiltered: true,
        sortOrder: 'asc',
        alignment: 'right',
      }),
      numCol({
        ident: 'gross',
        display: 'Gross',
        isFiltered: true,
        sortOrder: 'asc',
        alignment: 'right',
      }),
    ]),
    insertCompProps: {},
    allowCriteria: true,
    useDefaultUnit: false,
    initLoadApi: getTPSGenMapping,
    commonScreenProps: {
      withUnitSelection: true,
      withoutModify: true,
      isEditableGrid: _ => false,
      autoRetrieve: false,
      allowInsert: false,
    },
    retrieveTask: getTPSGenData,
    importTask: importTPSGenData,
  },
  'tps-lmp-data': {
    title: 'LMP Data (TPS Interface)',
    headers: lmpDataHeaders,
    insertCompProps: {},
    allowCriteria: true,
    useDefaultUnit: false,
    initLoadApi: getTPSLmpMapping,
    // unitConversionKey: '',
    commonScreenProps: {
      withUnitSelection: true,
      withoutModify: true,
      isEditableGrid: _ => false,
      autoRetrieve: false,
      allowInsert: false,
    },
    retrieveTask: getTPSLmpData,
    importTask: importTPSLmpData,
  },
  'tps-daaward-data': {
    title: 'DA Award Data (TPS Interface)',
    headers: genDataHeaders([
      numCol({
        ident: 'mw',
        display: 'MW',
        isFiltered: true,
        sortOrder: 'asc',
        alignment: 'right',
      }),
    ]),
    insertCompProps: {},
    allowCriteria: true,
    useDefaultUnit: false,
    initLoadApi: getTPSDAAwardMapping,
    // unitConversionKey: '',
    commonScreenProps: {
      withUnitSelection: true,
      withoutModify: true,
      isEditableGrid: _ => false,
      autoRetrieve: false,
      allowInsert: false,
    },
    retrieveTask: getTPSDAAwardData,
    importTask: importTPSDAAwardData,
  },
  'tps-makewhole-data': {
    title: 'Make Whole Data (TPS Interface)',
    headers: genDataHeaders([
      numCol({
        ident: 'credit',
        display: 'Credit',
        isFiltered: true,
        sortOrder: 'asc',
        alignment: 'right',
      }),
    ]),
    insertCompProps: {},
    allowCriteria: true,
    useDefaultUnit: false,
    initLoadApi: getTPSMakeWholeMapping,
    // unitConversionKey: '',
    commonScreenProps: {
      withUnitSelection: true,
      withoutModify: true,
      isEditableGrid: _ => false,
      autoRetrieve: false,
      allowInsert: false,
    },
    retrieveTask: getTPSMakeWholeData,
    importTask: importTPSMakeWholeData,
  },
  'tps-fuelprice-data': {
    title: 'Fuel Price Data (TPS Interface)',
    headers: genDataHeaders([
      numCol({
        ident: 'price',
        display: 'Fuel Price',
        isFiltered: true,
        sortOrder: 'asc',
        alignment: 'right',
      }),
    ]),
    insertCompProps: {},
    allowCriteria: true,
    useDefaultUnit: false,
    initLoadApi: getTPSFuelPriceMapping,
    // unitConversionKey: '',
    commonScreenProps: {
      withUnitSelection: true,
      withoutModify: true,
      isEditableGrid: _ => false,
      autoRetrieve: false,
      allowInsert: false,
    },
    retrieveTask: getTPSFuelPriceData,
    importTask: importTPSFuelPriceData,
  },
}

const getTPSScreenInfo = key => screenProps[key]

export default getTPSScreenInfo
